import(/* webpackMode: "eager" */ "/app/src/app/pools/page.tsx");
